import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import get from 'lodash/get';
import Router from 'next/router';

// Utils.
import dispatchWithPromise from 'utils/withPromise';
import { configureQuestionDetailsPageHead } from 'utils/configurePageHead';

// Componentns.
import Page from 'components/misc/BasePage';
import PageHead from 'components/misc/PageHead';
import PostsContent from 'pageContents/PostsContent';

import postApi from 'entity/post/postApi';
import { getPostRequest } from 'entity/post/postRedux';
import { getCommentsRequest } from 'entity/comment/commentRedux';
import { useGetJsonLdComments } from 'entity/comment/commentHooks';
import { useGetPostById } from 'entity/post/postHooks';
import { useIsSignedIn } from 'entity/user/userHooks';

const Posts = props => {
  const { slug: urlSlug, postId } = props;

  const jsonLdAnswers = useGetJsonLdComments();
  const postById = useGetPostById();
  const isSignedIn = useIsSignedIn();

  const dispatch = useDispatch();

  const post = postById[postId];

  const questionDetailsPageHead = configureQuestionDetailsPageHead(
    post,
    jsonLdAnswers,
  );

  useEffect(() => {
    postApi.updatePostPageView(postId);
    const actualSlug = get(postById, `[${postId}].slug`, '');

    if (urlSlug && urlSlug !== actualSlug) {
      const questionAs = `/posts?slug=${actualSlug}`;
      const actualLink = `/posts/${actualSlug}`;
      Router.push(questionAs, actualLink, { shallow: true });
    }
  }, [dispatch, postById, postId, urlSlug]);

  useEffect(() => {
    if (isSignedIn) {
      dispatch(getPostRequest(urlSlug, {}));
      dispatch(
        getCommentsRequest({
          commentableId: postId,
          commentableType: 'Post',
          page: 1,
        }),
      );
    }
  }, [dispatch, isSignedIn, postId, urlSlug]);

  return (
    <Page>
      <PageHead {...questionDetailsPageHead} />
      <PostsContent post={post} />
    </Page>
  );
};

Posts.getInitialProps = async ({ store, query, res }) => {
  const { slug, pcid, rcid } = query;
  await dispatchWithPromise(store.dispatch, getPostRequest, slug);
  const state = store.getState();

  const postId = state.post.ids[0];
  const post = state.post.byId[postId];
  const { slug: actualSlug } = post;

  if (res && slug && slug !== actualSlug) {
    const postLink = `/posts/${actualSlug}`;
    res.writeHead(301, { Location: postLink });
    res.end();
  }

  await dispatchWithPromise(store.dispatch, getCommentsRequest, {
    page: 1,
    commentableType: 'Post',
    commentableId: postId,
    ...(pcid && { pcid }),
    ...(rcid && { rcid }),
  });
  return { slug, postId };
};

export default Posts;
